import EfCouponCard from '@elem/ui/ef-coupon-card';
import EfModal from '@elem/ui/ef-modal';
import { Fragment } from 'react';
import IconEmpty from './IconEmpty';

export default function CouponWin({
    isOpen = false,
    prefixCls,
    TextA = {},
    callback,
    listCouponA = [],
}: {
    isOpen?: boolean;
    prefixCls?: string;
    TextA?: any;
    callback?: any;
    listCouponA?: any;
}) {
    const isEmpty = listCouponA.length === 0;

    return (
        <EfModal open={isOpen} className={`${prefixCls}-coupon-win ${prefixCls}-coupon-win-a`} callback={callback}>
            <div className={`${prefixCls}-coupon-title`}>{TextA.couponBtn}</div>
            {!isEmpty && (
                <div className={`${prefixCls}-coupon-list`}>
                    {listCouponA?.map((item: any, index: number) => {
                        const dataLayer_copy = {
                            event: 'uaEvent',
                            event_name: 'copy_promo_code',
                            title_name: item.coupon,
                            button_name: TextA.gtm_coupon,
                            position: TextA.couponBtn,
                        };
                        return (
                            <Fragment key={index}>
                                <EfCouponCard {...item} sqlItemData={item} showCouponName={true} dataLayer_copy={dataLayer_copy} />
                            </Fragment>
                        );
                    })}
                </div>
            )}
            {isEmpty && (
                <div className={`${prefixCls}-coupon-empty-box`}>
                    <IconEmpty />
                    <div className={`${prefixCls}-coupon-empty-msg`}>{TextA.no_coupon_note}</div>
                </div>
            )}
        </EfModal>
    );
}
